import {$m} from '@/app'

const pricelist_endpoints = new Set(['portal/offer-items', 'portal/filter/statistics'])

// A 404 from these endpoints means the relation's price list isn't generated yet — it's an expected,
// transient state (the shop collection polls until it's ready), so swallow it instead of surfacing an error.
function pricelist_available(request: {endpoint: string}, response: Response) {
    if (response.status === 404 && pricelist_endpoints.has(request.endpoint)) {
        return false
    } else if (response.status === 401) {
        $m.identity.logout_debounced()
        return false
    }
    return true
}

export default {
    get: [pricelist_available],
    post: [pricelist_available],
}
